export type DashboardDataType = {
  id: number;
  groupId: string;
  providerGroupName: string;
  speciality: string;
  providerCount: number;
  patientsCount: number;
  appointmentCount: number;
  encounterCount: number;
  status: string;
};

export const DASHBOARD_DATA: DashboardDataType[] = [
  {
    id: 1,
    groupId: "A8431",
    providerGroupName: "Intensive Care Medicine",
    speciality: "Tristan Dexter Intensive Care Medicine",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 2,
    groupId: "A8431",
    providerGroupName: "Intensive Care Medicine",
    speciality: "Tristan Dexter Intensive Care Medicine",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 3,
    groupId: "A8431",
    providerGroupName: "Card-ortho Surgery",
    speciality: "Augustine Angel   ",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Inactive",
  },
  {
    id: 4,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 5,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 6,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 7,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 8,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 9,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 10,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 11,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 12,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 13,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 18,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 14,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
  {
    id: 15,
    groupId: "A8431",
    providerGroupName: "Ophthalmology",
    speciality: "Iso process",
    providerCount: 4,
    patientsCount: 123,
    appointmentCount: 1234,
    encounterCount: 123,
    status: "Active",
  },
];

// Card key to status(es) query mapping
